import { HStack, VStack, colors, customEvent, Image, getCdnImageSrc, Spacing } from "goi_common";
import Link from "next/link";
import { useQuickCallModal } from "@/hooks/useQuickCallModal";
import { Box, Button } from "@chakra-ui/react";

export const StandBy24Hours = () => {
  const { onQuickCallModal } = useQuickCallModal();

  const handleChattingClick = () => {
    customEvent({
      newGtm: {
        path: "home",
        trigger_and_target: "chatting",
      },
    });
  };

  const handleInquiryClick = () => {
    onQuickCallModal();

    customEvent({
      newGtm: {
        path: "home",
        trigger_and_target: "24hour_standby-opn_call_mdl",
      },
    });
  };

  // const handleEstimateClick = () => {
  //   customEvent({
  //     newGtm: {
  //       path: "home",
  //       trigger_and_target: "24hour_standby-uv_mtch_rqst",
  //     },
  //   });
  // };
  return (
    <VStack width="100%" padding="0 20px">
      <VStack padding="24px" borderRadius="12px" gap={0} background={colors.blue150}>
        <Image src={getCdnImageSrc("platform/home/consultant.png")} width="48px" />
        <Spacing gap={4} />
        <Box className="subtitle_16_sb" color={colors.blue750}>
          임종접수, 긴급 문의가 있으시면
          <br />
          24시간 언제든 부담없이 연락해 주세요
        </Box>
        <Spacing gap={22} />
        <HStack gap="6px" alignItems="start">
          <Link href="https://pf.kakao.com/_xgFDaK/chat">
            <Button
              background={colors.white}
              border="none"
              padding="8px 12px"
              className="button_14_sb"
              onClick={handleChattingClick}
            >
              채팅문의
            </Button>
          </Link>
          <Button
            background={colors.white}
            border="none"
            padding="8px 12px"
            className="button_14_sb"
            onClick={handleInquiryClick}
          >
            전화문의
          </Button>
        </HStack>
      </VStack>
    </VStack>
  );
};
